import axios from "axios";
import { clientVitalsAPI, custId, proxyAPI } from "../secrets";
import { hash } from "../format";
import convert from 'xml-js';
import { Client } from "../types/UserTypes";
import { extractNames } from "../analysis/extract";

export const intialCreditPull = async (client: Client, ssn: string, password: string, uid: string) => { 
    try {
        const info_pwd = hash.formatCreditPassword(password);
        const names = extractNames(client.userInfo.name);

        const xmlString = `
        <?xml version="1.0" encoding="utf-8"?> 
        <data_area> 
            <header_data>
                <user_id>${uid.substring(0, 19)}</user_id> 
                <user_pwd>${info_pwd}</user_pwd> 
                <cus_id>${custId}</cus_id> 
                <xml_format>1</xml_format>
                <pre_qual>1</pre_qual> 
                <action>XPN|TU|EFX</action> 
            </header_data> 
            <applicant_data> 
                <applicant type="primary"> 
                    <person_name> 
                        <first_name>${names.first}</first_name> 
                        <middle_name>${names.middle}</middle_name> 
                        <last_name>${names.last}</last_name> 
                        <generation>${names.suffix}</generation>
                    </person_name> 
                    <address_data> 
                        <address type="current"> 
                            <line_one>${client.userInfo.address}</line_one> 
                            <city>${client.userInfo.city}</city> 
                            <state_or_province>${client.userInfo.state}</state_or_province> 
                            <postal_code>${client.userInfo.zip}</postal_code> 
                        </address> 
                    </address_data> 
                    <birthdate>${client.userInfo.dob}</birthdate>
                    <social>${ssn}</social>
                </applicant>
            </applicant_data> 
        </data_area>
        `
        
        const result = await axios.post(`${proxyAPI}/pull-credit`, xmlString, {
            headers: {
                'Accept': 'text/xml',
                'Content-Type': 'text/xml; charset=utf-8',
            }
        });
        
        return convert.xml2js(result.data, { compact: true });
    } catch (error) {
        throw error;
    }
};

export const fetchReportForAnalysis = async (link: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/dynamo/maps/report`, { link });
    
        return result?.data?.result;
    } catch (error) {
        throw error;
    }
};